import React from 'react';
import StatusBadge from '../shared/StatusBadge';
import './ProfileStatusCard.css';

const ProfileStatusCard = ({ profile }) => {
  const getStatusDisplay = (status) => {
    const statusMap = {
      'draft': { badge: 'draft', label: 'Draft' },
      'pending-review': { badge: 'pending-review', label: 'Pending Review' },
      'in-review': { badge: 'in-review', label: 'In Review' },
      'twilio-approved': { badge: 'approved', label: 'Approved' },
      'approved': { badge: 'approved', label: 'Approved' },
      'verified': { badge: 'approved', label: 'Approved' },
      'twilio-rejected': { badge: 'rejected', label: 'Rejected' },
    };
    return statusMap[status] || { badge: 'draft', label: status };
  };

  const statusDisplay = getStatusDisplay(profile.status);
  const lastUpdated = profile.updated_at ? new Date(profile.updated_at).toLocaleString() : 'N/A';

  return (
    <div className="profile-status-card">
      <div className="profile-status-header">
        <div className="profile-status-info">
          <h2 className="profile-status-title">
            Business Profile Status:
          </h2>
          <StatusBadge status={statusDisplay.badge} label={statusDisplay.label} size="large" />
        </div>
        {/* <div className="profile-metadata">
          <span className="metadata-item">
            <strong>Last Updated:</strong> {lastUpdated}
          </span>
        </div> */}
      </div>

      {/* Status Messages */}
      {profile.status === 'twilio-approved' && (
        <div className="status-message status-message-success">
          <div>
            <strong>Your business profile has been approved</strong>
            <p>You can now use this profile for Voice, SMS, and VoIP compliance.</p>
          </div>
        </div>
      )}

      {profile.status === 'pending-review' && (
        <div className="status-message status-message-warning">
          <div>
            <strong>Your business profile is pending review</strong>
            <p>Typically reviews profiles within 3-5 business days.</p>
          </div>
        </div>
      )}

      {profile.status === 'in-review' && (
        <div className="status-message status-message-warning">
          <div>
            <strong>Your business profile is currently in review</strong>
            <p>Your profile is being evaluated. This typically takes 3-5 business days.</p>
          </div>
        </div>
      )}

      {profile.status === 'twilio-rejected' && (
        <div className="status-message status-message-error">
          <div>
            <strong>Your business profile has been rejected.</strong>
            <p>Please review the rejection reason and update your profile information.</p>
          </div>
        </div>
      )}

      {profile.status === 'draft' && (
        <div className="status-message status-message-info">
          <div>
            <strong>Your business profile is in draft status</strong>
            <p>Complete and submit your profile for review to enable compliance features.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileStatusCard;
